import React from "react"

export type TypingContextType = {
  awaitingUserSentence: boolean
  setAwaitingUserSentence: (value: boolean) => void
  awaitingESKResponse: boolean
  setAwaitingESKResponse: (value: boolean) => void
  draftMessage: string
  setDraftMessage: (value: string) => void
}

const TypingContext = React.createContext<TypingContextType | null>(null)

export const TypingProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [awaitingUserSentence, setAwaitingUserSentence] = React.useState<boolean>(false)
  const [awaitingESKResponse, setAwaitingESKResponse] = React.useState<boolean>(false)
  const [draftMessage, setDraftMessage] = React.useState<string>("")

  const value = {
    awaitingUserSentence,
    setAwaitingUserSentence,
    awaitingESKResponse,
    setAwaitingESKResponse,
    draftMessage,
    setDraftMessage,
  }
  return <TypingContext.Provider value={value}>{children}</TypingContext.Provider>
}

export const useTyping = () => {
  const context = React.useContext(TypingContext)
  if (!context) {
    throw new Error("useTyping must be used within an TypingProvider")
  }
  return context
}
